(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    

// Intercept all add-to-cart forms
document.addEventListener('submit', function(e) {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;

  e.preventDefault();

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(res => res.json())
  .then(item => {
    // Populate drawer
    document.getElementById('cart-drawer__img').src = item.image;
    document.getElementById('cart-drawer__img').alt = item.title;
    document.getElementById('cart-drawer__title').textContent = item.product_title;
    document.getElementById('cart-drawer__variant').textContent = item.variant_title ? item.variant_title.toUpperCase() : '';

    // Update cart count
    return fetch('/cart.js');
  })
  .then(res => res.json())
  .then(cart => {
    document.getElementById('cart-drawer__view').textContent = `VIEW CART (${cart.item_count})`;
    openDrawer();
  });
});

function openDrawer() {
  document.getElementById('cart-drawer').classList.add('is-open');
}

function closeDrawer() {
  document.getElementById('cart-drawer').classList.remove('is-open');
}

document.querySelector('.cart-drawer__close').addEventListener('click', closeDrawer);
document.querySelector('.cart-drawer__overlay').addEventListener('click', closeDrawer);
document.querySelector('.cart-drawer__continue').addEventListener('click', closeDrawer);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    const menu = document.getElementById('mobileMenu');
    const openBtn = document.getElementById('menuOpen');
    const closeBtn = document.getElementById('menuClose');
  
    openBtn.addEventListener('click', () => {
      menu.classList.add('active');
    });
  
    closeBtn.addEventListener('click', () => {
      menu.classList.remove('active');
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const section = document.getElementById('related-products');
  const productId = section.dataset.productId;
  const sectionId = section.closest('.shopify-section').id.replace('shopify-section-', '');

  fetch(`/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=4`)
    .then(res => res.text())
    .then(text => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newGrid = html.querySelector('.grid.featured');
      if (newGrid) section.querySelector('.grid.featured').innerHTML = newGrid.innerHTML;
    });

  } catch(e) { console.error(e); }
})();
})();
